module.exports = __webpack_public_path__ + "img/PAG310_1-1.d088c8ce.jpg";